export default "__VITE_PUBLIC_ASSET__bf4ec9ae__"